import clsx from 'clsx';
import React from 'react';
import CloseIcon from '../icons/close-icon';

export type Severity = 'error' | 'warning' | 'info' | 'success';

type Props = {
  title?: string;
  severity?: Severity;
  onClose?: () => void;
};

const severityClassNames: Record<Severity, string> = {
  error: 'border-[#C73131] text-[#C73131] bg-[#FDF5F5]',
  warning: 'border-[orange] text-[orange] bg-[#FDF5F5]',
  info: 'border-primary text-primary bg-white',
  success: 'border-[#2E4D51] text-[#2E4D51] bg-[#CBF0E4]',
};

const severityIconColor: Record<Severity, string> = {
  error: '#C73131',
  warning: 'orange',
  info: '#36B6E6',
  success: '#2E4D51',
};

const Alert: React.FC<Props> = ({
  title,
  severity = 'info',
  onClose,
  children,
}) => (
  <div
    className={clsx(
      'flex items-center justify-between space-x-4 rounded border border-solid px-4 py-1.5',
      severityClassNames[severity],
    )}
  >
    <div>
      {title && <strong>{title} </strong>}
      {children}
    </div>
    {onClose && (
      <div className="cursor-pointer" onClick={onClose}>
        <CloseIcon color={severityIconColor[severity]} />
      </div>
    )}
  </div>
);

export default Alert;
